<template>
	<div class="pagesContent">
		<!-- 主体内容 -->
		<div class="contain">
			<div class="top">
				<div class="toptxt">
					牙管家后台管理系统
				</div>
			</div>
			<div class="main">
				<el-input class="loginInput" v-model="username" placeholder="请输入用户名" prefix-icon="el-icon-user-solid"
					@keyup.enter.native="loadBtn"></el-input>
				<el-input class="loginInput" v-model="password" placeholder="请输入密码" prefix-icon="el-icon-s-goods"
					show-password @keyup.enter.native="loadBtn"></el-input>
				<div class="canvasNumber">
					<canvas style="width: 200px; height: 38px;border-radius:4px;border:1px solid #dcdfe6;" canvas-id="firstCanvas" id="firstCanvas"></canvas>
					<el-input style="margin-left: 10px;" v-model.number="arithmetic" placeholder="请输入结果" />
				</div>
				<!-- 滑动验证 -->
				<!-- <div class="moveBox">
					<div class="movego"></div>
					<div class="txt" id="txt">按住滑块,拖动到最右边</div>
					<div class="move moveBefore" v-move="pull"></div> v-move 为自定义指令
				</div> -->
				<!-- <button class="loginBtn" @click="loadBtn" style="width: 100%; color: #FFFFFF;"> 登录</button> -->
				<el-button :loading="loading" class="loginBtn" style="width: 100%;" type="primary" @click='loadBtn()'>登录
				</el-button>
			</div>
		</div>
	</div>
</template>

<script>
import rsa from '/src/utils/rsa.js';
// import tfVerifyImg from '../components/tf-verify-img_1.0.2/components/tf-verify-img/tf-verify-img.vue';
	export default {
		data() {
			return {
				showVerify:false,
				loading:false,
				//用户名
				username: '',
				password: '',
				checkMove: false,
				key: "",
				nums: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
				result: '',
      			arithmetic: ""
			}
		},
		//注册自定义的指令,对普通 DOM 元素进行底层操作，就会用到自定义指令
		directives: {
			move(el, binding, vnode) {
				var system ={};
				var p = navigator.platform;
				system.win = p.indexOf("Win") == 0;
				system.mac = p.indexOf("Mac") == 0;
				system.xll = (p == "X11") || (p.indexOf("Linux") == 0);
				if(system.win||system.mac||system.xll){
					el.onmousedown = function(e) {
						var X = e.clientX - el.offsetLeft;
						document.onmousemove = function(e) {
							var endx = e.clientX - X;
							el.className = "move moveBefore";
							el.style.left = endx + "px";
							var width = document.querySelector(".moveBox").offsetWidth - document.querySelector(
								".move").offsetWidth;
							el.parentNode.children[0].style.width = endx + "px";
							el.parentNode.children[1].innerHTML = "按住滑块,拖动到最右边";
							//临界值小于
							if (endx <= 0) {
								el.style.left = 0 + "px";
								el.parentNode.children[0].style.width = 0 + "px";
							}
							//临界值大于
							if (parseInt(el.style.left) >= width) {
								el.style.left = width + "px";
								el.parentNode.children[0].style.width = width + "px";
								el.parentNode.children[1].innerHTML = "<span style='color:#fff'>验证通过</span>";
								el.className = "move moveSuccess";
								document.onmousemove = null;
								el.onmousedown = null;
								binding.value()
							}
						};
					};
				}else {
					console.log("000",p)
					el.ontouchstart = function(e) {
						var X = e.clientX - el.offsetLeft;
						document.ontouchmove = function(e) {
							var endx = e.clientX - X;
							el.className = "move moveBefore";
							el.style.left = endx + "px";
							var width = document.querySelector(".moveBox").offsetWidth - document.querySelector(
								".move").offsetWidth;
							el.parentNode.children[0].style.width = endx + "px";
							el.parentNode.children[1].innerHTML = "按住滑块,拖动到最右边";
							//临界值小于
							if (endx <= 0) {
								el.style.left = 0 + "px";
								el.parentNode.children[0].style.width = 0 + "px";
							}
							//临界值大于
							if (parseInt(el.style.left) >= width) {
								el.style.left = width + "px";
								el.parentNode.children[0].style.width = width + "px";
								el.parentNode.children[1].innerHTML = "<span style='color:#fff'>验证通过</span>";
								el.className = "move moveSuccess";
								document.onmousemove = null;
								el.onmousedown = null;

								binding.value()
							}
						};
					};
				}
				el.onmousedown = function(e) {
					var X = e.clientX - el.offsetLeft;
					document.onmousemove = function(e) {
						var endx = e.clientX - X;
						el.className = "move moveBefore";
						el.style.left = endx + "px";
						var width = document.querySelector(".moveBox").offsetWidth - document.querySelector(
							".move").offsetWidth;
						el.parentNode.children[0].style.width = endx + "px";
						el.parentNode.children[1].innerHTML = "按住滑块,拖动到最右边";
						//临界值小于
						if (endx <= 0) {
							el.style.left = 0 + "px";
							el.parentNode.children[0].style.width = 0 + "px";
						}
						//临界值大于
						if (parseInt(el.style.left) >= width) {
							el.style.left = width + "px";
							el.parentNode.children[0].style.width = width + "px";
							el.parentNode.children[1].innerHTML = "<span style='color:#fff'>验证通过</span>";
							el.className = "move moveSuccess";
							document.onmousemove = null;
							el.onmousedown = null;

							binding.value()
						}
					};
				};
				document.onmouseup = function() {
					document.onmousemove = null;
				};
			}
		},
		mounted() {
			// console.log(this.UserData);
			this.getRSAPublicKey()
			// this.$router.push({ path: '/home/index' })
			this.$nextTick(() => {
				this.init()
			})
			console.log(this.$store)
		},
		methods: {
			init() {
				let first = Math.floor(Math.random() * this.nums.length)
				let second = Math.floor(Math.random() * this.nums.length)
				this.result = first + second
				const context = document.getElementById("firstCanvas").getContext("2d")
				context.font = 'bold 60px cursive'
				context.fillStyle = '#333';
				context.fillText(first, 0, 80);
				context.fillStyle = 'red';
				context.fillText("+", 65, 80);
				context.fillStyle = 'blue';
				context.rotate(10 * Math.PI / 180)
				context.fillText(second, 120, 80);
				context.fillStyle = 'red';
				context.rotate(-10 * Math.PI / 180)
				context.fillText("=", 180, 80);
				// context.setFillStyle("#333");
				// context.setFontSize(20)
				// context.fillText(first, 0, 30);
				// context.setFillStyle("red");
				// context.fillText("+", 30, 30);
				// context.setFillStyle("blue");
				// context.rotate(10 * Math.PI / 180)
				// context.fillText(second, 50, 30);
				// context.setFillStyle("red");
				// context.rotate(-10 * Math.PI / 180)
				// context.fillText("=", 80, 40);
				// context.setFontSize(40)
				// context.setFillStyle("red");
				// context.fillText("?", 100, 50);
				// context.draw()
				// this.$emit('result', result)
			},


			// 获取rsa加密公钥
			async getRSAPublicKey(){
				try{
					let res = await this.$http.getRSAPublicKey()
					this.key = res.data.base64
					// console.log(res);
				}catch(e){
					this.$message.error(`获取加密公钥失败，请重试${e}`)
				}
			},
			/* 自定义指令 */
			pull() {
				this.checkMove = true;
			},
			/* 登录按钮 */
			loadBtn() {
				// var msg = rsa.setRsa(this.key,this.password)
				// console.log( msg );
				// console.log( rsa.getRsa(msg) );
				// return 
				// && this.checkMove
				if (this.username != '' && this.password != ''&&this.result==this.arithmetic) {
					// 接口登录验证
					// 对用户名、密码特殊字符进行编码 （不会对  - _ . ! ~ * ' ( )  字符编码）
					var username = encodeURIComponent(this.username)
					var password = encodeURIComponent(this.password)
					let user = '?userName=' + username + '&password=' + rsa.setRsa(this.key,this.password)
					// let user = '?userName=' + username + '&password=' + password
					this.loading = true
					this.$http.Login(user).then(res => {
						this.loading = false
						if (res.data.Code == 200) { //登录成功
							//登录成功 返回信息 存入缓存
							var UserData = JSON.stringify(res.data.RltData)
							localStorage.setItem('UserData', UserData) //localStorage 只支持字符串
							var user_key = (new Date().getTime() + (1000 * 60 * 60) )
							// var user_key = (new Date().getTime() + (1000 * 30) )
							localStorage.setItem('user_key',user_key)
							this.$message.success('登录成功')
							setTimeout(() => {
								this.$router.push({
									path: '/home/index'
								})
							}, 1000)
							//跳转主页
						} else { //code 100 登录失败
							this.$message.error({
								message: res.data.MsgText,
							});
						}
					}).catch(res => {
						this.loading = false
						this.$message.error('登录失败')
					})
				} else { //信息未填写完整
					if (this.username == '') {
						this.$message.error('请输入用户名！');
					} else if (this.password == '') {
						this.$message.error('请输入密码！');
					} else if (this.result!==this.arithmetic) {
						this.$message.error('请计算验证');
					} else {
						this.$message.error('请检查信息是否完整！');
					}
				}
			}
		}
	}
</script>

<style scoped>
	.arithmetic-mverify {
		width: 100%;
		position: relative;
		box-sizing: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.arithmetic-num{
		width: 150rpx;
		font-size: 16rpx *2;
		color: #333;
	}
	.canvasNumber{
		margin-top:25px;
		display: flex;
	}


	* {
		margin: 0;
		padding: 0;
	}

	.pagesContent {
		width: 100%;
		height: 100vh;
		/* background-color: #F0F0F4; */
		background-image: url(../../static/background.jpg);
	}

	.contain {
		width: 500px;
		height: 460px;
		background-color: #FFFFFF;
		border-radius: 10px;
		position: absolute;
		top: 160px;
		left: calc((100% - 500px) / 2);
	}

	.top {
		height: 130px;
		line-height: 130px;
		background-image: url(../../static/sky.jpg);
		border-radius: 10px 10px 0 0;
	}

	.toptxt {
		color: #FFFFFF;
		font-size: 20px;
		font-weight: bold;
		text-align: center;
		background-color: rgba(0, 0, 0, 0.4);
		border-radius: 10px 10px 0 0;
	}

	.main {
		height: 330px;
		padding: 15px 50px 40px 50px;
		box-sizing: border-box;
	}

	.loginInput {
		margin-top: 25px;
	}

	.loginBtn {
		margin-top: 30px;
		height: 40px;
		border: #409EFF 1px solid;
		border-radius: 4px;
		background-image: linear-gradient(to right, #409EFF, #7BCAEC);
	}

	/* 滑块验证 */
	.moveBox {
		position: relative;
		background-color: #EEEEEE;
		width: 400px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		margin-top: 25px;
		border-radius: 4px;
	}

	.txt {
		position: absolute;
		top: 0px;
		width: 400px;
		-moz-user-select: none;
		-webkit-user-select: none;
		user-select: none;
		-o-user-select: none;
		-ms-user-select: none;
		font-size: 12px;
		color: #666666;
		border-radius: 4px;
	}

	.movego {
		background-color: #65CC65;
		height: 40px;
		width: 0px;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
	}

	.move {
		position: absolute;
		top: 0px;
		left: 0px;
		width: 62px;
		width: 50px;
		height: 40px;
		box-sizing: border-box;
	}

	.moveBefore {
		width: 62px;
		height: 40px;
		border: 2px solid #EEEEEE;
		background: url(../assets/scroll_a.png) no-repeat;
		background-color: #FFFFFF;
		border-radius: 4px;
	}

	.moveSuccess {
		width: 62px;
		height: 40px;
		border: 2px solid #EEEEEE;
		background: url(../assets/scroll_b.png) no-repeat;
		border-radius: 4px;
	}
</style>
